import HttpMethod from '@/consts/httpMethod';
import { processRequest } from '@/helpers';

export default {
  async activityLog(key, data = {}) {
    const ep = {
      baseURL: process.env.VUE_APP_LOGGER_API_ROOT,
      url: '/v1/activity-logs/',
      method: HttpMethod.POST
    };

    await processRequest(ep, {
      data: {
        key,
        data
      }
    }, false);
  }
};
